<template>
    <div>
        <v-dialog v-model="show" max-width="800" scrollable overlay-color="#000" light>
            <v-card>
                <v-card-title class="d-flex justify-space-between">
                    
                    <v-btn color="primary" block large @click="generateInvoicePDF" depressed class="medium-text">
                        <v-icon size="23" left>mdi-printer</v-icon>
                        اضغط للطباعة
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="order" class="pa-0">
                    <div id="orderInvoicePrint">
                        <div class="invoice printable">
                            <div class="header" style="padding: 2rem 2.5rem 0 2.5rem; background: #ffffff; color: #000;">
                                <div style="display: flex; justify-content: space-between; width: 100%">
                                    <div>
                                        <h2 class="default-font" style="font-weight: normal!important">فاتورة الطلب #{{order.local_serial}}</h2>
                                        <div class="details-text" style="direction: ltr; text-align: right; margin-top: 7px;">{{dateTimeFormat(order.created_at, true)}}</div>
                                    </div>
                                    <div>
                                        <div style="margin-bottom: 8px; display: flex;">
                                            <img v-if="storeData.logo" :src="storeData.logo" style="max-height: 45px; max-width: 130px" />
                                            <h1 v-else style="font-size: 26px; line-height: auto;">{{storeData.name}}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding: 0 2.5rem 2rem 2.5rem;">
                                <v-simple-table class="pa-0 bordered transparent" style="margin: 1rem 0">
                                    <tbody>
                                        <tr class="font-weight-bold">
                                            <td>{{order.name}}</td>
                                        </tr>
                                        <tr class="font-weight-bold">
                                            <td style="text-align: right; direction: ltr">{{order.phone_code}} {{order.phone}}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding-top: 10px!important; padding-bottom: 10px!important">
                                                <div class="font-weight-bold">{{order.city}}</div>
                                                <div style="white-space: pre-line;">{{order.address}}</div>
                                            </td>
                                        </tr>
                                        <tr v-if="order.notes">
                                            <td>
                                                <div style="white-space: pre-line;">{{order.notes}}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                                <v-simple-table class="cart-table pa-0 bordered transparent" style="margin: 1rem 0">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-right font-weight-medium">المنتج</th>
                                                <th class="text-right font-weight-medium">السعر</th>
                                                <th class="text-center font-weight-medium">الكمية</th>
                                                <th class="text-center font-weight-medium">الإجمالي</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item) in order.items" :key="item.id">
                                                <td class="d-flex align-center" style="height: 90px">
                                                    <div>
                                                        <!-- <div style="width: 60px; height: 60px; background-size: cover; background-position: center;" :style="`background-image: url(${item.product.main_image_url})`" /> -->
                                                        <div style="display: flex; align-items: center; justify-content: center; width: 60px; height: 60px; overflow: hidden; bordered">
                                                            <img :src="item.product.main_image_url" style="height: 60px; width: auto; object-fit: cover;" />
                                                        </div>
                                                    </div>
                                                    <div style="margin-right: 12px!important">
                                                        <div class="mb-1 strong-text--text" style="font-size: 16px; line-height: 1.4">{{item.product.name}}</div>
                                                        <div class="text--text" style="font-size: 14px">{{item.variant.name}}</div>
                                                    </div>
                                                </td>
                                                <td>{{moneyFormat(item.purchasing_price)}}</td>
                                                <td class="text-center">
                                                    {{item.quantity}}
                                                </td>
                                                <td class="text-center">
                                                    <div>
                                                        <b class="medium-text">{{moneyFormat(item.total)}}</b>
                                                    </div>
                                                </td>
                                                <!-- <td class="text-left">
                                                    <v-btn icon outlined color="error" width="35" height="35" @click="removeFromCart(item.id)">
                                                        <v-icon size="18">mdi-close</v-icon>
                                                    </v-btn>
                                                </td> -->

                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>

                                <v-simple-table class="pa-0 bordered transparent" style="margin: 1rem 0">

                                    <tbody>
                                        <tr v-for="(row, i) in totalTable" :key="i">
                                            <td class="medium-text" :class="{'text--text': !row.bold, 'strong-text--text font-weight-bold': row.bold}">{{row.text}}</td>
                                            <td class="medium-text strong-text--text" :class="{'font-weight-bold': row.bold}">{{row.value}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <!-- <v-divider style="margin: 2rem 0 1rem 0"></v-divider> -->

                                <div class="invoice-footer" style="margin-top: 3rem">
                                    <!-- <v-divider style="margin: 1rem 0;"></v-divider> -->
                                    <div>
                                        <div style="display: flex; justify-content: center; align-items: center; flex-grow: 1;">
                                            <span style="color: #000; font-size: 13px">تم إنشاء الفاتورة بواسطة</span>
                                            <logo style="margin: 0 10px" normal width="75" :link="false" light />
                                            <!-- <span style="margin: 0 4px">أحد أنظمة: </span>
                                            <logo style="margin: 0 8px" ebmsoft light :height="15" :link="false" /> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
// import { 7 } from "jspdf";
// import PrintJs from 'print-js'

export default {
    props: {
        order: {},
        value: {},
    },
    components: {},
    data(){
        return {
            show: false,
        }
    },
    computed: {
        ...GlobalComputed,

        totalTable(){
            const orderData = this.order;
            let rows = [
                {text: 'عدد المنتجات', value: orderData.items_count},
                {text: 'المجموع', value: this.moneyFormat(orderData.subtotal, true)},
                {text: 'الإجمالي', value: this.moneyFormat(orderData.total, true), bold: true},
            ];
            return rows;
        },
    },
    methods: {
        ...GlobalMethods,
        generateInvoicePDF(){
            var prtContent = window.document.getElementById('orderInvoicePrint');
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(prtContent.innerHTML);

            window.document.querySelectorAll('link[rel="stylesheet"]').forEach(link=>{
                link = link.cloneNode(true);
                WinPrint.document.body.classList.add('v-application');
                WinPrint.document.body.appendChild(link);
            });
            window.document.querySelectorAll('style').forEach(style=>{
                style = style.cloneNode(true);
                if (style.innerHTML.search('print') === -1){
                    WinPrint.document.body.appendChild(style);
                }
            });

            var style=document.createElement("style");
            style.setAttribute("type", "text/css");
            style.innerHTML = `
                body {
                    font-family: 'Cairo', 'Arial';
                    direction: rtl;
                    margin: 0!important;
                }
                h1, h2, p{
                    margin: 0;
                }
                .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
                    color: #000!important;
                }
                tr th{
                    height: 38px!important;
                }
                tr th, tr td{
                    padding: 0 16px!important;
                    // border-bottom: none!important;
                }
                .text-right{
                    text-align: right;
                }
                .text-left{
                    text-align: left;
                }
                .text-center{
                    text-align: center;
                }

                .py-1{
                    padding-top: 4px !important;
                    padding-bottom: 4px !important;
                }
                .row {
                    margin-right: 0!important;
                    margin-left: 0!important;
                }
                .v-application *.muted--text{
                    color: #000!important;
                }
                .v-application *.black--text{
                    color: #000!important;
                }
                .v-application *.text--text, td{
                    color: #000!important;
                }
                .col{
                    padding-right: 0!important;
                    padding-left: 0!important;
                }
                .v-icon{
                    color: #000;
                }
                .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
                    color: #000!important;
                    white-space: nowrap;
                    font-weight: normal;
                }
                .v-application *.text-wrap {
                    white-space: normal !important;
                }
                .v-application .d-flex{
                    display: flex!important;
                }
                .v-application .align-center{
                    align-items: center;
                }
                .v-application .font-weight-bold{
                    font-weight: 700!important;
                }
            `;
            WinPrint.document.body.appendChild(style);
            window.setTimeout(()=>{
                WinPrint.focus();
                WinPrint.print();
                WinPrint.document.close();
                WinPrint.close();
            }, 600);
        },
    },
    watch: {
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        },
    },
    mounted(){
        if (this.value){
            this.show = this.value;
        }
    }
}
</script>

<style lang="scss">
#orderInvoicePrint{
    /* table tr td, table tr th{
        border-bottom: none!important;
    }     */
    tr th{
        height: 38px!important;
    }
}
</style>
